import {
    Box,
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    useTheme
} from "@mui/material";
import {
    ChevronLeft,
    ChevronRightOutlined,
    Store,
    HistoryEdu,
    PeopleAlt,
    MobileFriendly,
    Apartment,
    Dns,
    Phishing,
    SettingsInputAntenna,
    WifiTethering,
    Settings,
    Description
} from "@mui/icons-material";
import logo from '../assets/img/logo-white.png'
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import FlexBetween from './FlexBetween';
import { TYPE_APPOINTMENTS, TYPE_MOBILE, TYPE_SURVEY } from '../constants/projectTypes';
import { useProjectTypeContext } from './ProjectTypeProvider';

const getNavItems = (project) => [   
    {
        text: "Compañías",
        icon: <Apartment/>,
        path: "dash/companies"
    },
    {
        text: "Sucursales",
        icon: <Store/>,
        path: "dash/branches"
    },
    {
        text: "Licencias",
        icon: <HistoryEdu/>,
        path: "dash/licenses"
    },
    {
        text: "Usuarios",
        icon: <PeopleAlt/>,
        path: "dash/users"
    },
    {
        text: "Soporte",
        icon: <Settings/>,
        path: "dash/support"
    },
    //VISTAS MICROSERVICIO APPOINTMENTS
    ...(project === TYPE_APPOINTMENTS) ? [
        {
            text: "Server Tasks",
            icon: <Dns/>,
            path: "dash/appointments/server-tasks"
        },
        {
            text: "Hooks",
            icon: <Phishing/>,
            path: "dash/appointments/hooks"
        },
        {
            text: "Conexión con Mobile",
            icon: <MobileFriendly/>,
            path: "dash/appointments/mobile-connection"
        }
    ] : [],
    //VISTAS MICROSERVICIO MOBILE
    ...(project === TYPE_MOBILE) ? [
        {
            text: "Server Tasks",
            icon: <Dns/>,
            path: "dash/mobile/server-tasks"
        },
        {
            text: "Proveedores",
            icon: <SettingsInputAntenna/>,
            path: "dash/mobile/providers"
        }
    ] : [],
    //VISTAS MICROSERVICIO SURVEY
    ...(project === TYPE_SURVEY) ? [
        {
            text: "Conexión con Mobile",
            icon: <WifiTethering/>,
            path: "dash/survey/mobileConnection"
        },{
            text: "Templates",
            icon: <Description/>,
            path: "dash/survey/templates"
        },
    ] : [],
];


const Sidebar = ({
    user,
    drawerWidth,
    open,
    setOpen,
    isNonMobile
}) => {
    const {pathname} = useLocation();
    const [active, setActive] = useState("");
    const navigate = useNavigate();
    const theme = useTheme();
    const [navItems, setNavItems] = useState([]);
    const {projectTypeValue} = useProjectTypeContext();
    useEffect(() => {
        setActive(pathname.substring(1));
    }, [pathname])

    useEffect(() => {
        setNavItems(getNavItems(projectTypeValue));
    },[projectTypeValue]);

  return (
    <Drawer 
        sx={{
            width: drawerWidth,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            bgcolor: theme.palette.primary.main,
            borderWidth: 0,
            color: theme.palette.neutral.main,
            },
        }}
        variant="persistent"
        anchor="left"
        open={!open}
    >
        
        <Box width="100%">
        <Box m="1.5rem 2rem 2rem 2rem">
            <FlexBetween color={theme.palette.secondary[200]} display="flex" alignItems="center">
                <Box 
                    component="img"
                    alt="profile"
                    src={logo}
                    width="100%"
                    sx={{objectFit: "cover" }}
                    style={{cursor:'pointer'}}
                /> 
                
                {!isNonMobile && (
                    <IconButton onClick={() => setOpen(!open)} >
                        <ChevronLeft />
                    </IconButton>
                )}
            </FlexBetween>
        </Box>
        <List>
            {navItems.map(({text, icon, path}) => {
                
                return (
                    <ListItem key={text} disablePadding>
                        <ListItemButton onClick={() => {
                            navigate(`/${path}`); 
                            setActive(path);
                            }}
                            sx={{
                                backgroundColor: active === path ? theme.palette.primary.dark : "transparent",
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    ml: "1rem",
                                    color: "inherit"
                                }}
                            >
                                {icon}
                            </ListItemIcon>
                            <ListItemText primary={text} />
                            {active === path && (
                                <ChevronRightOutlined sx={{ml: "auto"}} />
                            )}
                        </ListItemButton>
                    </ListItem>
                );
            })}
        </List>
        </Box>


    </Drawer>

  );
}

export default Sidebar;

